module.exports = __webpack_public_path__ + "img/malaga.be291795.jpg";